module.exports = __webpack_public_path__ + "static/media/mental.93c892db.png";